$(function () {

    var $form = $('.js-form-contact');

    if ($form.length === 0) {
        return;
    }

    $form_wrapper = $form.parent('.form__parent');

    $form.parsley().on('form:submit', function (event) {
        console.log('contact form submit');

        var url = $form.attr('action'),
            hasError = false,
            data = [],

            // csrf
            $tokenInputField = $form.find('#token'),
            postTokenName = $tokenInputField.attr('name'),
            postTokenValue = $tokenInputField.val(),

            // form fields
            $first_name = $form.find('[name=first_name]'),
            $last_name = $form.find('[name=last_name]'),
            $email = $form.find('[name=email]'),
            $phone = $form.find('[name=phone]'),
            $language = $form.find('[name=language]'),
            $message = $form.find('[name=message]'),
            $names_ = $form.find('[name=names_]'),
            $form_name = $form.find('[name=form_name]'),
            $submit = $form.find('[name=submit]');

        function isValidEmail(email) {
            let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        $form.find('.input').prop("disabled", true);
        $form.find('.error').remove();
        $form.find('.field_error').removeClass('field_error');
        hasError = false;

        $submit.addClass('loading');

        data = {
            first_name: $first_name.val() || '',
            last_name: $last_name.val() || '',
            email: $email.val() || '',
            phone: $phone.val() || '',
            language: $language.val() || '',
            message: $message.val() || '',
            names_: $names_.val() || '',
            form_name: $form_name.val() || '',
            submit: $submit.val() || ''
        };

        $.ajax({
            type: "post",
            beforeSend: function (request) {
                request.setRequestHeader('X-' + postTokenName, postTokenValue);
            },
            url: url,
            data: data,
            dataType: 'json'
        })
            .done(function (data) {

                console.log('Form result: ', data);

                if (data.error) {
                    // handle php validation error

                    $form.find('.error').remove();
                    $form.find('.field_error').removeClass('field_error');

                    $.each(data.errors, function (field, msg) {
                        var $field = $('#' + field);
                        $field.addClass('field_error');
                        $field.after("<span class='error'>" + msg + "</span>");
                    });

                } else {
                    // success
                    console.log('success');

                    $form_wrapper.slideUp(400, function () {
                        $form_wrapper.html(data.message);
                        $form_wrapper.slideDown(300);
                    });
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log('ajax failed', textStatus);
            })
            .always(function () {
                $form.find('.input').prop("disabled", false);
                $submit.removeClass('loading');
            });

        return false;
    });
});